import { UserRole } from '../types';

/**
 * Role Mapper Utility
 * Maps backend roles to display names and vice versa
 */

// Mapping from backend roles to display names
const ROLE_DISPLAY_MAP: Record<string, string> = {
  ORG_ADMIN: 'ORGANIZATION ADMIN',
  OUTLET_POC: 'RECRUITER',
  OUTLET_MANAGER: 'MANAGER',
};

// Reverse mapping from display names to backend roles
const DISPLAY_ROLE_MAP: Record<string, UserRole> = {
  'ORGANIZATION ADMIN': 'ORG_ADMIN',
  RECRUITER: 'OUTLET_POC',
  MANAGER: 'OUTLET_MANAGER',
};

/**
 * Maps backend role to display name
 * @param backendRole - Backend role (e.g., 'ORG_ADMIN')
 * @returns Display name (e.g., 'ORGANIZATION ADMIN')
 */
export const mapRoleToDisplay = (backendRole?: UserRole | string): string => {
  if (!backendRole) return '';
  return ROLE_DISPLAY_MAP[backendRole] || backendRole;
};

/**
 * Maps display name to backend role
 * @param displayName - Display name (e.g., 'ORGANIZATION ADMIN')
 * @returns Backend role (e.g., 'ORG_ADMIN')
 */
export const mapRoleToBackend = (displayName?: string): UserRole | string => {
  if (!displayName) return '';
  return DISPLAY_ROLE_MAP[displayName] || displayName;
};

/**
 * Returns available roles for dropdown (display names)
 * @returns Array of display role names
 */
export const getAvailableRoles = (): string[] => {
  return Object.values(ROLE_DISPLAY_MAP);
};
